import { Injectable } from '@angular/core';
import { shareReplay, tap } from 'rxjs/operators';
import { ConfigurationHttpClient } from '../httpclient/configuration.httpclient';
import { EMPTY, Observable } from 'rxjs';
import { EMPTY_FOOTER_URLS, FooterUrls } from '../models/footerUrls';

@Injectable({ providedIn: 'root' })
export class FooterUrlService {
  private _configuration$: Observable<FooterUrls> = EMPTY;
  public configuration: FooterUrls = EMPTY_FOOTER_URLS;

  public constructor(private readonly configurationHttpClient: ConfigurationHttpClient) {}

  public get urlCgv(): string {
    return this.configuration.urlCgv;
  }
  public get urlMentionsLegales(): string {
    return this.configuration.urlMentionsLegales;
  }

  public get urlPolitiqueConf(): string {
    return this.configuration.urlPolitiqueConf;
  }

  public get urlUtilConf(): string {
    return this.configuration.urlUtilConf;
  }

  private get _configFile(): string {
    return `assets/config/footer.json`;
  }

  /**
   * Retourne la configuration propre à l'environnement
   */
  public load(): Observable<FooterUrls> {
    if (this._configuration$ === EMPTY) {
      this._configuration$ = this.configurationHttpClient.get<FooterUrls>(this._configFile).pipe(
        shareReplay(1),
        tap((configuration: FooterUrls) => {
          this.configuration = { ...configuration };
        }),
      );
    }

    return this._configuration$;
  }
}
